<template>
  <transition name="shake">
    <div
      v-if="errors[0]"
      class="text-danger"
    >
      {{ errors[0] }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ValidationFeedback',
  props: {
    errors: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .shake-enter-active {
    animation: shake 0.5s;
  }

  @keyframes shake {
    8%, 41% {
      -webkit-transform: translateX(-10px);
    }

    25%, 58% {
      -webkit-transform: translateX(10px);
    }

    75% {
      -webkit-transform: translateX(-5px);
    }

    92% {
      -webkit-transform: translateX(5px);
    }

    0%, 100% {
      -webkit-transform: translateX(0);
    }
  }
</style>
